import React, { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ItemsMain from "./ItemsMain";
import { ItemsStore, RolesAndPermissionStore } from "../../../shared/store";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

interface IProps {
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
}
const ItemRoutes: FC<IProps> = ({
  itemStore,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  return (
    <Routes>
      <Route
        path={`/*`}
        element={
          <ItemsMain
            itemStore={itemStore}
            rolesAndPermissionStore={rolesAndPermissionStore}
            merchantAccountStore={merchantAccountStore}
          />
        }
      />
      <Route path="*" element={<Navigate to="/items" />} />
    </Routes>
  );
};

export default ItemRoutes;
